import React from 'react';
import { Box, Typography, Sheet } from '@mui/joy';

interface FooterProps {
  organizationName?: string;
}

export const Footer: React.FC<FooterProps> = ({ organizationName }) => {
  return (
    <Sheet
      component="footer"
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.level1',
        mt: 'auto',
        py: 3,
        px: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Typography level="body-sm" sx={{ color: 'text.secondary' }}>
          © {new Date().getFullYear()} ApexOS. All rights reserved.
        </Typography>
        
        {organizationName && (
          <Typography level="body-sm" sx={{ color: 'text.secondary' }}>
            {organizationName}
          </Typography>
        )}
      </Box>
    </Sheet>
  );
};